import axios from "axios";
var BASE_URL = process.env.BASE_URL_GATEWAY;
var BaseService = /** @class */ (function () {
    function BaseService() {
        this.activeRequests = 0;
        this._api = this.createInstance(BASE_URL);
    }
    Object.defineProperty(BaseService.prototype, "api", {
        get: function () {
            return this._api;
        },
        enumerable: false,
        configurable: true
    });
    BaseService.prototype.createInstance = function (baseURL) {
        var _this = this;
        var headers = {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-Api-Key": "".concat(process.env.API_KEY_GATEWAY),
            "App-Key": "".concat(process.env.APP_KEY),
        };
        axios.defaults.baseURL = baseURL;
        var instance = axios.create({
            baseURL: baseURL,
            headers: headers,
        });
        instance.interceptors.request.use(function (config) {
            ++_this.activeRequests;
            return config;
        }, function (error) {
            --_this.activeRequests;
            return Promise.reject(error);
        });
        instance.interceptors.response.use(function (response) {
            --_this.activeRequests;
            return response;
        }, function (error) {
            --_this.activeRequests;
            return Promise.reject(error);
        });
        return instance;
    };
    return BaseService;
}());
export { BaseService };
